module Meevo.Plugins.Accountsync {
    class OpenedDrawerListController {

        static $inject = [
            'drawersList',
            '$mdDialog'
        ];

        constructor(
            protected drawersList: any,
            protected $mdDialog: angular.material.IDialogService
        ) { }


        /**
         * Close modal window
         * */
        public cancel(): void {
            this.$mdDialog.cancel();
        }
    }

    angular.module('meevo.plugins.accountsync')
        .controller('meevo.plugins.accountsync.OpenedDrawerListController', OpenedDrawerListController);
}